<template>
  <div>
    <el-dialog :visible.sync="visible" @close="closeDialog" slot="title" width="65%" top="20px">
      <template slot="title">
        <div>
          <h3>Notify</h3>
          <el-divider style="font-weight: bold"></el-divider>
        </div>
      </template>

      <el-row class="title">
        <el-col :span="24">
          <span>{{ entity.title }}</span>
        </el-col>
      </el-row>
       <el-row class="title2">
        <el-col :span="24">
          <span>{{ entity.startTime }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" v-html="entity.content"> </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      entity: {},
      visible: this.dialogVisible,
    }
  },
  created() {},
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    //传递用户ID
    setId(id, isRead) {
      this.$get(`notify/get/${id}/${isRead}`).then(({ data: res }) => {
        console.log(res)
        this.entity = res.data
      })
    },
  },
  watch: {
    dialogVisible(oldValue, newValue) {
      this.visible = this.dialogVisible
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding-top: 0px !important;
  min-height: 500px !important;
  min-width: 400px !important;
}
.title {
  margin: 0px;
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 5px;
}
.title2{
  text-align: right;
  font-size: 16px;
  padding-right: 40px;
  margin-bottom: 10px;
}
</style>